import React from 'react'
import { IUser } from '@/model/types/user'
import { ColumnsType } from 'antd/lib/table'
import { Table } from 'antd'
import $msg from '@/utils/message'
import { $post } from '@/api'
import { useRequest } from 'ahooks'
import { IPagination } from '@/model/types/common'
import { AutoResizer, WithScrollLoad } from '@/utils/utils-widget'
import { showLayer } from '@/utils/layer'
import { Goods } from '@/model/types/goods'
import ReduceDetailInfo from '../stock-update-detail/update-detail-info'
import StockReduceForm from '../stock-update-form/stock-update-form'

export interface LossGoodsInfo {
    goods: Goods
    id: number
    loss_amount: number
    remark: string
    stock_original: number
    stock_surplus: number
}

interface InventoryLossList {
    goods_sum: number
    order_no: string
    status: number
    id: number
    update_time: string
    create_time: string
    creator: {
        id: number
        user: IUser
    }
    goods_info: LossGoodsInfo
}

interface StockUpdateTableProps {
    refreshStatus: boolean
    date: string[]
}

const StockReduceTable: React.FC<StockUpdateTableProps> = props => {
    const columns: ColumnsType<InventoryLossList> = [
        {
            title: '#',
            key: 'index',
            width: 50,
            render: (value, record, index) => index + 1,
        },
        {
            title: '报损时间',
            key: 'update_time',
            dataIndex: 'update_time',
            render: value => value,
        },
        {
            title: '报损商品数',
            key: 'goods_sum',
            dataIndex: 'goods_sum',
            render: value => value,
        },
        {
            title: '状态',
            key: 'status',
            width: 80,
            dataIndex: 'status',
            render: val => <div className={val ? '' : 'danger-color'}>{!val ? '草稿' : '已报损'}</div>,
        },
        {
            title: '操作',
            key: 'action',
            width: 70,
            dataIndex: 'status',
            align: 'center',
            render: (val, record) => (
                <span
                    className="action"
                    onClick={() => {
                        showLayer(
                            val ? (
                                <ReduceDetailInfo inventyId={record.id} />
                            ) : (
                                <StockReduceForm refresh={requestHandle.refresh} inventoryId={record.id} />
                            ),
                        )
                    }}
                >
                    {!val ? '编辑' : '详情'}
                </span>
            ),
        },
    ]

    const requestHandle = useRequest<
        {
            list: InventoryLossList[]
            pagination: IPagination
        },
        {
            inventory_loss_list: InventoryLossList[]
            pagination: IPagination
        }
    >(
        val => {
            return $post({
                url: '/warehouse/getinventorylossreportlist',
                params: {
                    limit: 20,
                    page: val?.pagination?.page ? val.pagination.page + 1 : 1,
                    from_date: props.date[0],
                    to_date: props.date[1],
                },
            })
        },
        {
            isNoMore: data => {
                if (data?.pagination) {
                    return data?.pagination.page === data?.pagination.page_count
                } else {
                    return false
                }
            },
            loadMore: true,
            formatResult: data => {
                return {
                    list: data.inventory_loss_list,
                    pagination: data.pagination,
                }
            },
            onError: e => {
                $msg('error', e.message)
            },
            refreshDeps: [props.refreshStatus, props.date],
        },
    )

    return (
        <div className="table-container">
            <AutoResizer>
                {({ height }) => {
                    return (
                        <WithScrollLoad data-expaned data-overflow-hidden scrollloadhandle={requestHandle}>
                            <Table
                                rowKey={record => record.id}
                                loading={requestHandle.loading || void 0}
                                bordered
                                pagination={false}
                                columns={columns}
                                dataSource={requestHandle.data?.list}
                                scroll={{ x: 'max-content', y: height - 50 }}
                            />
                        </WithScrollLoad>
                    )
                }}
            </AutoResizer>
        </div>
    )
}

export default StockReduceTable
